import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import {
    INPUT_TYPES
} from "constants/index";


const getFormFields = () =>
    new OrderedMap({
        name: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Name",
            rules: [
                {
                    required: true,
                    message: "Required"
                }
            ],
            category: 1
        },
        bankCode: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Code",
            rules: [
                {
                    required: true,
                    message: "Required"
                },
            ],
            category: 1
        }
    });

class AddLender extends React.Component {

    state = {};

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, { channel_products, sellers, anchor, primary_relationship_manager, vp_sales, ...restValues}) => {
                if (!err) {
                    const contact_detail = {
                        first_name: restValues.first_name,
                        last_name: restValues.last_name,
                        email: restValues.email,
                        phone: restValues.phone,
                        nature_of_association: restValues.nature_of_association
                    };
                    this.props.onValuesSubmit(
                        {
                            gstin: restValues.gstin,
                            type: restValues.type,
                            channel_products: channel_products && channel_products.map(_ => _.id),
                            sellers: sellers && sellers.map(_ => _.id),
                            is_also_anchor: restValues.is_also_anchor === "true" ? true : false,
                            anchor: restValues.is_also_anchor === "true" ? undefined : anchor && anchor.id,
                            primary_relationship_manager: primary_relationship_manager && primary_relationship_manager.id,
                            vp_sales: vp_sales && vp_sales.id,
                            contact_detail,
                            bank: restValues.bank == 0 ? null : restValues.bank,
                        }
                    );
                }
            });
        }
    };

    formatData = (data) => {
        if(data) {
            return data.map(_ => {
                return {
                    ..._,
                    name: `${_.name} (${_.gstin})`
                };
            });
        }
        return data;
    }

    formFields = getFormFields({
        gstinValidator: this.props.gstinValidator,
        allFieldsDisabled: this.props.loading,
        gstinDisabled: this.props.gstinDisabled
    });

    render() {
        return (
            <Form layout={"vertical"} onSubmit={this.onValuesSubmit}>
                {this.formFields.map((field, fieldName) => {
                    field.disabled = this.props.disableFields;
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </Form>
        );
    }
}

AddLender.propTypes = {
    form: PropTypes.object,
    companyValues: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    gstinValidator: PropTypes.object,
    gstinDisabled: PropTypes.bool,
    fetchChannelProducts: PropTypes.func,
    salesManagers: PropTypes.array,
    loading: PropTypes.bool,
    spocValues: PropTypes.array,
    bankDetails: PropTypes.object,
    disableFields: PropTypes.bool,
    fetchSalesManagers: PropTypes.func,
    detail: PropTypes.object
};

AddLender.defaultProps = {
    salesManagers: [],
    disableFields: false
};

export default Form.create({})(AddLender);
